<!-- eslint-disable @intlify/vue-i18n/no-raw-text -->
<template>
  <f7-block>
    <p>Muestra un un contador numérico con botones de incremento y decremento</p>
    <ol>
      <li>Permite ingresar un valor numérico.</li>
      <li>Permite establecer un límite máximo.</li>
      <li>Emite un evento cuando su valor cambia.</li>
    </ol>
    <div class="display-flex justify-content-center">
      <UCInputIncrement :max-valor="Number(5)" />
    </div>
  </f7-block>
</template>

<script>
import UCInputIncrement from '@/components/common/UCInputIncrement.vue';

export default {
  name: 'TestUCInputIncrement',
  components: {
    UCInputIncrement,
  },
};
</script>
